import { doorClient, resolve, ImResponse } from '.';

// https://leyan.yuque.com/czpqnb/yzt2rg/qawgwp#K9hlz

/** 查询客服在线状态列表 */
export function assistantListOnlineStatus() {
  return resolve(
    doorClient.get<ImResponse<Assistant.AssistantOnlineStatusInfo[]>>(
      `/overseaim-store-home/v1/assistant/list/online-status`,
    ),
  );
}

/** 查询客服组在线状态列表 */
export function assistantGroupOnlineStatus() {
  return resolve(
    doorClient.get<ImResponse<Assistant.AssistantGroupOnlineStatusInfo[]>>(
      `/overseaim-store-home/v1/assistant-group/online-status`,
    ),
  );
}
